<template>
	<div class="downloads">
		<banner title="联系我们" :img="sty" />
		<div style="background-color: #fafafa;padding-top: 47px;padding-bottom: 67px;">
			<div class="neirong">
				<div class="top clearfix">
					<div class="topleft">
						<img src="../assets/img/zhaoxiannashi.png" alt="">
						<p class="biaoti">INVITE TO ONE'S SIDE MEN OF WISDOM AND VALOR</p>
						<p class="common">
							中艺储运江苏有限责任公司是由各种人才支撑起来的一方天地，中艺储运江苏有限责任公司的价值由员工共同创造。我们视员工为公司最宝贵的财富，愿意吸纳优秀且具有潜力的人才，并希望每一位员工都能在公司得到良好发展。
						</p>
						<p class="common">
							中艺储运江苏有限责任公司由个性鲜活的个人组成，我们看重人，尊重人，坚信员工个人的进步与企业的发展息息相关。中艺储运的生命力源于员工的创造力，员工孜孜以求，公司就蒸蒸日上；员工锐意创新，公司则活力常存。公司的发展需要由员工的力量来驱动，员工个人的发展需要公司提供机遇和发展空间。因此，让企业和员工都得到最好的发展，是我们的追求。
						</p>
						<p class="tishi">
							我们的使命：以人为本，制度管理，专业化服务，致力于企业价值与员工价值的共同提升。</p>
						<p class="common">
							中艺储运江苏有限责任公司尊重每一位员工，尊重员工的个人意愿，尊重员工的选择权利，更尊重员工的创造力；所有员工在人格上人人平等，在发展机会上人人平等；提供良好的环境，营造和谐向上的工作氛围，倡导简单而真诚的人际关系。
						</p>
					</div>
					<img class="topright" src="../assets/img/rencairight.png" alt="">
				</div>
				<div class="gangweilist">
					<div v-for="(item,index) in list" :class="{'li':item.show}" :key="index">
						<div @click="xianshi(index)" class="on">
							<div class="name">{{item.title}}</div>
							<div class="detail">
								查看详情
							</div>
						</div>
						<div :style="{display:(item.show==true?'block':'none')}" class="yaoqiu">
							<div class="lieju">
								
								<p>部门<span>{{item.bumen}}</span></p>
								<p>发布时间<span>{{item.fabushijian}}</span></p>
								<p>薪资待遇<span>{{item.xinzi}}</span></p>
								<p>工作年限<span>{{item.gongzuonianxian}}</span></p>
								<p>学历<span>{{item.xueli}}</span></p>
								<p>招聘人数<span>{{item.renshu}}</span></p>
								<p>职位有效期<span>{{item.youxiaoqi}}</span></p>
								<p style="width: 100%;">工作地点<span>{{item.didian}}</span></p>
							</div>
							<div class="gangwei">
								<h2>岗位要求</h2>
								<div class="detail" v-html="item.yaoqiu"></div>
								
								<el-button @click="dialogVisible = true" class="sendresume" type="warning">投递简历</el-button>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<el-dialog
			title="欢迎投递简历或直接联系我们"
			:visible.sync="dialogVisible"
			top="30vh"
			width="600px">
			<div class="contact">
				<ul>
					<li>
						<i class="el-icon-phone-outline"></i>
						<div>联系电话：</div>
						<div class="val">{{ tel }}</div>
					</li>
					<li>
						<i class="el-icon-message"></i>
						<div>邮箱地址：</div>
						<div class="val">{{ email }}</div>
					</li>
				</ul>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>


	</div>
</template>

<script>
	import maps from "@/components/map";
	import Banner from "../components/Banner";
	export default {
		components: {
			Banner,
			maps,
		},
		data() {
			return {
				form: {
					descp: "",
					phone: "",
					email: "",
					wechat: '',
					doinflag: ''
				},
				textarea2: "",
				list: [],
				sty: {
					backgroundImage: "url(" + require("@/assets/img/rencai.jpg") + ")",
				},
				dialogVisible: false,
				tel: '',
				email: ''
			};
		},
		mounted() {
			this.getData();
			this.getContact();
		},
		methods: {
			//获取联系方式
			getContact(){
				this.$axios({
					method: "get",
					url: "webpc/pcmastercompany/list",
				}).then(res => {
					if (res.data.result == 200) {
						let data = res.data.detail;
						this.tel = data.company_phone;
						this.email = data.email;
					}
				
				})
			},
			getData(){
				var that = this;
				that.$axios({
					method: "post",
					url: "/webpc/pcrecruitjoin/pageList",
					// data: this.$qs.stringify(data)
					params: {
						flag:0
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					var data = res.data.detail.list;
					if(data.length > 0){
						for(var i = 0;i<data.length;i++){
								data[i].show = true;
						}
					}
					that.list = data;
					
				})
			},
			xianshi(a) {
				for(var i = 0;i<this.list.length;i++){
					if(i == a){
						this.list[i].show = !this.list[i].show;
					}
				}
			},
			getlunbo() {
				var that = this;
				that.$axios({
					method: "get",
					url: "system/pcmanage/list",
					// data: this.$qs.stringify(data)
					params: {
						location: 6
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					// console.log(res.data.data);
					if (res.data.result == 200) {
						console.log(res.data)
						var data = res.data.detail;
						that.sty = {
							backgroundImage: "url(" + data[0].showpath + ")",
						}
					}

				})
			},
			handelClickSubMit() {
				var that = this;

				// if(that.msg.name.trim() == ''){
				// 	that.$message.error("请填写姓名");
				// 	return;
				// }
				if (that.form.phone.trim() == '') {
					that.$message.error("请填写手机");
					return;
				}
				if (that.form.email.trim() == '') {
					that.$message.error("请填写邮箱");
					return;
				}
				if (that.form.descp.trim() == '') {
					that.$message.error("请填写内容");
					return;
				}
				that.loading1 = true;
				that.$axios({
					method: "post",
					url: "webpc/pconlinemessage/list",
					// data: this.$qs.stringify(data)
					params: {
						email: that.form.email,
						descp: that.form.descp,
						type: 1,
						phone: that.form.phone
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					var data = res.data.data;
					that.loading1 = false;
					if (res.data.result == 200) {
						that.$message({
							message: '提交成功',
							type: 'success'
						});
						that.form.email = '';
						that.form.descp = '';
						that.form.phone = '';
						// var data = result.data.data;
						// that.zhengshu = [];
						// for(var i = 0;i<data.length;i++){
						// 	that.zhengshu.push({
						// 		tu:data[i].attas[0].path
						// 	});
						// }

					}
				})
				// this.$http
				// 	.post("/system/pconlinemessage/add", this.form)
				// 	.then((res) => {
				// 		this.$message.success("意见反馈成功");
				// 	});
			},
			// handelClickSubMit() {
			//   //提交按钮
			//   this.$message.error("您还没有登录，请登陆后提交");
			// },
		},
	};
</script>

<style lang="scss" scoped>
	.contact{
		ul{
			li{
				margin: 10px;
				display: flex;
				align-items: center;
				font-size: 16px;
				i{
					margin-right: 10px;
					font-size: 20px;
				}
				.val{
					margin-left: 10px;
					color: #ed8600
				}
			}
		}
	}
	.neirong {
		width: 1200px;
		margin: auto;
	}

	.neirong .top {

		margin-bottom: 35px;
	}

	.neirong .top .topright {
		float: right;
		width: 332px;

	}

	.neirong .top .topleft {
		float: left;
		width: 850px;
	}

	.neirong .top .topleft img {
		display: block;
		width: 196px;
		height: 80px;
		margin-bottom: 6px;
	}

	.neirong .top .topleft .biaoti {
		font-size: 16px;
		color: #5c81ac;
		margin-bottom: 12px;
	}

	.neirong .top .topleft p {
		font-size: 16px;
		margin-bottom: 12px;
	}

	.neirong .top .topleft .common {
		color: #3e3a39;
		line-height: 1.6rem;
		text-indent: 32px;
	}

	.neirong .top .topleft .tishi {
		line-height: 1.8rem;
		color: #ed8600;
	}

	.yaoqiu {
		padding: 10px 40px 20px;
		background-color: #fff;
		transition: all 0.5s;
	}

	.yaoqiu .lieju {
		width: 80%;
		margin-bottom: 25px;
		padding: 10px 20% 20px 0;
		border-bottom: 1px solid #e9ebed;
		overflow: hidden;
	}
	.yaoqiu .lieju p{
		width: 25%;
		float: left;
		font-size: 14px;
		color: #222;
		line-height: 26px;
	}
	.yaoqiu .lieju p span{
		color: #565656;
		padding-left: 15px;
	}
	.gangweilist>div{
		border-bottom: 1px solid #e9ebed;
		transition: all 0.5s;
	}
	.gangwei{
		position: relative;
	}
	.gangwei h2{
		font-size: 14px;
		color: #222;
		line-height: 30px;
		margin-bottom: 15px;
	}
	.gangwei .detail{
		line-height: 150%;
		color: #565656;
		font-size: 14px;
	}
	.gangwei .btn{
		font-size: 14px;
		line-height: 20px;
		color: #005ba0;
		// cursor: pointer;
		// transition: all 0.5s;
	}

	.gangwei .sendresume{
		position: absolute;
		bottom: 20px;
		right: 0;
	}
	.gangweilist .li .on{
		background-color: #005ba0;
		color: #fff;
	}
	.on{
		overflow: hidden;
		height: 52px;
		line-height: 52px;
		padding: 0 40px;
		color: #fff;
		background-color: #005ba0;
		font-size: 14px;
		cursor: pointer;
		transition: all 0.5s;
	}
	.on .name{
		float: left;
	}
	.on .detail{
		float: right;
		padding-right: 30px;
		background: url(../assets/img/job-icon1.png) right center no-repeat;
	}
	.gangweilist .li .on .detail{
		background: url(../assets/img/job-icon2.png) right center no-repeat;
	}
	.gangweilist>div>div{
		transition: all 0.5s;
	}
</style>
